import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { TOOLTIPS_TEXTS } from '@tripointe/tripointe-cms/constants';
import { NotificationsSettings } from '@tripointe/tripointe-cms/types';

@Component({
  selector: 'tp-notifications-assignment',
  templateUrl: './notifications-assignment.component.html',
  styleUrls: ['./notifications-assignment.component.scss']
})
export class NotificationsAssignmentComponent {
  @Input() notifications: NotificationsSettings[] = [];
  @Input() showPushNotifications = true;
  @Output() selectionChange = new EventEmitter();

  tooltips = TOOLTIPS_TEXTS.userForm;

  notificationChange(
    { checked }: MatSlideToggleChange,
    indexOfChanged: number,
    field: 'email' | 'text'
  ): void {
    const newState = this.notifications.map((notification, i) => {
      return i === indexOfChanged ? { ...notification, [field]: checked } : notification;
    });

    this.selectionChange.emit(newState);
  }
}
